const getMerchantsApiUrl = (state) => state.getIn(['config', 'shopsmallMerchantApiUrl']);

export default getMerchantsApiUrl;
